import Vue from 'vue'
import Router from 'vue-router'
import Camps from '@/components/camps/camps'
import NotFound from '@/components/NotFound'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Camps',
      component: Camps
    },
    {
      path: '*',
      name: '404',
      component: NotFound
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js